import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';

import Styled from './styles';

export interface DialogContentProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the `DialogContent`. */
  children: React.ReactNode;
  /** If `true`, the top border will be visible. */
  isTopDividerVisible?: boolean;
  /** If `true`, the bottom border will be visible. */
  isBottomDividerVisible?: boolean;
  /** If `false`, there will be a padding on the bottom of the container. */
  footer?: boolean;
  /** To override the HorizontalDivider theme. Please refer to the "Readme" tab to learn more. */
  dividerTheme?: {};
}

/** All props will be provided to the wrapper element. */
const DialogContent = React.forwardRef<HTMLElement, DialogContentProps>((props: DialogContentProps, ref) =>
  getContext(({ RTL, theme }) => {
    const {
      DIVIDER: dividerTheme
    } = theme;
    const {
      children,
      isTopDividerVisible,
      isBottomDividerVisible,
      dividerTheme: diverThemeProp,
      footer,
      ...otherProps
    } = props;
    const resolvedTheme = _merge({}, { DIVIDER: { ...dividerTheme } }, { DIVIDER: { ...diverThemeProp } });
    return (
      <Styled.Content
        $theme={resolvedTheme}
        isTopDividerVisible={isTopDividerVisible}
        isBottomDividerVisible={isBottomDividerVisible}
        footer={footer}
        ref={ref}
        RTL={RTL}
        {...otherProps}
      >
        {children}
      </Styled.Content>
    );
  }));

DialogContent.displayName = 'DialogContent';
DialogContent.defaultProps = {
  isTopDividerVisible: false,
  isBottomDividerVisible: false,
  footer: true,
  dividerTheme: {}
};
export default DialogContent;
